import { render } from "./Education.vue?vue&type=template&id=25f8256d&scoped=true&ts=true"
import script from "./Education.vue?vue&type=script&lang=ts"
export * from "./Education.vue?vue&type=script&lang=ts"

import "./Education.vue?vue&type=style&index=0&id=25f8256d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f8256d"]])

export default __exports__